import React from "react";
import { useNavigate } from "react-router-dom";
import "./WelcomePage.css";
import Navbar from "../../components/Navbar/Navbar";
import Button from "../../components/Button/Button";

function WelcomePage() {
  const navigate = useNavigate();

  return (
    <div className="welcome-container">
      <Navbar />
      <main className="welcome-content">
        <div className="welcome-image">
          <div className="welcome-text">
            <h1>Hey There! <span className="waving-hand">👋🏻</span></h1>
            <h2>Your Sole - Mate Awaits!</h2>
            <div className="feature-text">
              <p>Your guide to finding the perfect pair.</p>
              <p>Skip the scroll, Browse Faster and Smarter</p>
              <p>We're live for your queries 24/7</p>
              <p>Unlock Secret Deals</p>
            </div>
          </div>
        </div>
        <Button
          onClick={() => navigate("/preferences")}
          size="medium"
          className="same-width"
        >
          Let's go!
        </Button>
      </main>
    </div>
  );
}

export default WelcomePage;